module.exports = __webpack_public_path__ + "media/images/header-bg2-96fcede47e25b2883d34dc63feb1d8e1.png";